module.exports = __webpack_public_path__ + "static/img/9.50b892c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/9.png
// module id = pBzy
// module chunks = 0